import { Box, Stack, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import styles from "./MenuItem.module.css";

const MenuItem = ({ text, icon, path, onClick, isOpen }) => {
    const theme = useTheme();
    const Component = path ? Link : "div";

    const handleClick = (e) => {
        if (onClick) {
            e.preventDefault();
            onClick();
        }
    };

    return (
        <Stack
            direction="row"
            spacing={2}
            component={Component}
            onClick={handleClick}
            to={path}
            className={styles.menuItem}
            style={{
                "--hoverBackgroundColor": theme.palette.action.hover,
            }}
            sx={[
                {
                    justifyContent: isOpen ? "flex-start" : "center",
                    padding: isOpen ? "10px 16px" : "10px",
                    textDecoration: path ? "none" : "inherit",
                    color: path ? "inherit" : "inherit",
                },
            ]}
        >
            <Box className={styles.menuItemIcon}>{icon}</Box>
            {isOpen && <Box className={styles.menuItemText}>{text}</Box>}
        </Stack>
    );
};

export default MenuItem;
